import React, { useEffect, useRef } from 'react';
import { Icon } from 'components/_shared/Icon';
import { REVIEW_STATUS_TITLES } from '../../constants';
import {
  Rail,
  Item,
  Num,
  Body,
  Top,
  Size,
  ClassTag,
  MockedTag,
  StatusLine,
  Pager,
  PagerButton
} from './QueueList.styles';

const STATUS_ICON = {
  pending: { name: 'Cross', color: 'gray' },
  confirmed: { name: 'Check', color: 'green' },
  rejected: { name: 'Cross', color: '#b3261e' }
};

const sizeLabel = stone => (stone.size_cm == null ? 'No size' : `${stone.size_cm} cm`);

export const QueueList = ({
  stones,
  current,
  onSelect,
  page,
  pageSize,
  pageCount,
  onPageChange
}) => {
  const activeRef = useRef();

  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [current]);

  return (
    <Rail aria-label='Stones'>
      {stones.map((stone, i) => {
        const icon = STATUS_ICON[stone.review];
        return (
          <Item
            key={stone.id}
            type='button'
            aria-pressed={i === current}
            onClick={() => onSelect(i)}
            ref={i === current ? activeRef : null}
          >
            <Num>{(page - 1) * pageSize + i + 1}</Num>
            <Body>
              <Top>
                <Size>{sizeLabel(stone)}</Size>
                {stone.size_class && (
                  <ClassTag>{stone.size_class.toUpperCase()}</ClassTag>
                )}
                {stone.size_is_mocked && <MockedTag>mocked</MockedTag>}
              </Top>
              <StatusLine>
                <Icon color={icon.color}>{icon.name}</Icon>
                {REVIEW_STATUS_TITLES[stone.review]} · {stone.field.name}
              </StatusLine>
            </Body>
          </Item>
        );
      })}
      {pageCount > 1 && (
        <Pager>
          <PagerButton
            type='button'
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            ‹
          </PagerButton>
          <span>
            Page {page} of {pageCount}
          </span>
          <PagerButton
            type='button'
            disabled={page >= pageCount}
            onClick={() => onPageChange(page + 1)}
          >
            ›
          </PagerButton>
        </Pager>
      )}
    </Rail>
  );
};
